import { type BETranslateableText } from "~/common/types";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";

interface Props {
  label: BETranslateableText;
  type: "primary" | "secondary";
  href?: string;
}

const BEButton = (data: Props) => {
  const { t } = useTranslation();

  let label;
  if (typeof data.label === "string") {
    label = data.label;
  } else {
    const { key, ...params } = data.label;
    label = t(key, params);
  }

  return (
    <Button color={data.type} href={data.href}>
      {label}
    </Button>
  );
};

export function create(data: Props) {
  return <BEButton {...data} />;
}
